module.exports = __webpack_public_path__ + "static/media/5.0214e414.jpg";